import React, { createContext, useContext, useState, useEffect } from "react";
import { useGroup } from "./GroupContext";

const TournamentConfigContext = createContext();

const DEFAULT_CONFIG = {
  daysOfWeek: [
    "11. April", "12. April", "13. April", "14. April", "15. April",
    "16. April", "17. April", "18. April", "19. April"
  ],
  maxFreikarten: 4,
  stundenlohn: 13.90,
  rateOptions: [6.95, 13.90],
  bonusOptions: [0, 6.95, 13.90, 20.85],
};

export const TournamentConfigProvider = ({ children }) => {
  const { activeGroup } = useGroup();
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [configLoading, setConfigLoading] = useState(true);

  useEffect(() => {
    if (!activeGroup) return;

    const groupConfig = activeGroup.config || {};
    setConfig({
      daysOfWeek: groupConfig.daysOfWeek || DEFAULT_CONFIG.daysOfWeek,
      maxFreikarten: groupConfig.maxFreikarten ?? DEFAULT_CONFIG.maxFreikarten,
      stundenlohn: groupConfig.stundenlohn ?? DEFAULT_CONFIG.stundenlohn,
      rateOptions: groupConfig.rateOptions || DEFAULT_CONFIG.rateOptions,
      bonusOptions: groupConfig.bonusOptions || DEFAULT_CONFIG.bonusOptions,
    });
    setConfigLoading(false);
  }, [activeGroup]);

  const updateConfig = (newConfig) => {
    setConfig(newConfig);
  };

  return (
    <TournamentConfigContext.Provider value={{ ...config, configLoading, updateConfig }}>
      {children}
    </TournamentConfigContext.Provider>
  );
};

export const useTournamentConfig = () => {
  const ctx = useContext(TournamentConfigContext);
  if (!ctx) throw new Error("useTournamentConfig must be used within TournamentConfigProvider");
  return ctx;
};
